import axios, { AxiosError } from 'axios';
import { API_GATEWAY_BASE_URL } from '@/core/global-data/constants.data';
import { clearAuthTokens } from '@/features/auth/guard/utils';

// ------------- AXIOS DEFAULTS SETTINGS -------------
// ---------------------------------------------------
const defaultURL = API_GATEWAY_BASE_URL;

axios.defaults.baseURL = defaultURL;

// ------------- GLOBAL ERROR HANDLER -------------

const handleUnauthorized = () => {
    // 1. Clear authentication tokens
    clearAuthTokens();

    // 2. Redirect to login page (using window.location to avoid circular dependency)
    window.location.href = '/login';
};

// ------------- CREATE AXIOS INTERCEPTORS -------------
// ----------------------------------------------------

axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        const status = error.response?.status;
        const isUnauthorized = status === 401 || status === 403;

        if (isUnauthorized && !error.config?.url?.includes('/login')) {
            handleUnauthorized();
        }

        return Promise.reject(error);
    },
);

// -------------------------------------------------------

export const endpoints = {
    auth: {
        login: '/login',
        profile: '/user',
        me: '/me',
        resetPassword: '/reset-password',
    },
    offers: {
        dashboard: '/offers-dashboard',
        list: '/offers-list',
        show: '/offers-show/',
        update: '/offers-update/',
        delete: '/offers-delete/',
        create: '/offers-create',
    },

    // branch: {
    //     list: '/branch-list',
    //     show: '/branch-show/',
    //     update: '/branch-update/',
    //     delete: '/branch-delete/',
    //     create: '/branch-create',
    //     dashboard: 'branch-dashboard',
    // },
};
